import Menu from '@mui/icons-material/Menu';
import { Box, IconButton } from '@mui/material';
import { useInterviewOptions } from '@providers/InterviewsProvider';
import { memo, useEffect } from 'react';
import { useProSidebar } from 'react-pro-sidebar';
import { Outlet } from 'react-router-dom';

function RouterOutletContents() {
    const { toggleSidebar } = useProSidebar();
    const { selectedInterview } = useInterviewOptions();

    useEffect(() => {
        if (!selectedInterview) {
            toggleSidebar(true);
        }
    }, [selectedInterview, toggleSidebar]);

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                overflowY: 'auto', // Allow scrolling for non-DataGrid screens (e.g., InterviewEditor)
                width: '100%',
                flex: 1,
                minHeight: 0, // Allow flex shrinking
            }}
        >
            <Box sx={{ display: { xs: 'flex', lg: 'none' } }}>
                <IconButton
                    aria-label="delete"
                    className="btn-toggle"
                    onClick={() => toggleSidebar()}
                >
                    <Menu />
                </IconButton>
            </Box>

            {/* This element will render on all routes */}
            <Outlet />
        </div>
    );
}

export default memo(RouterOutletContents);
